import { useState, useRef } from 'react';
import toast from 'react-hot-toast';
import Modal from '../modal';
import LoadingSpinner from '../loading-spinner/loading-spinner';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { fetch } from '../../utils/api-wrapper';

const ImportTransactionsModal = ({ isOpen, data, onClose, refreshCcards, fileFormatExample, accountMask = null }) => {
  const [importFile, setImportFile] = useState('');
  const [importErrors, setImportErrors] = useState([]);
  const [processingImport, setProcessingImport] = useState(false);
  const importInputRef = useRef(null);

  if (!isOpen) return null;

  const closeAndReset = () => {
    setImportFile('');
    setImportErrors([]);
    setProcessingImport(false);
    if (importInputRef.current) importInputRef.current.value = '';
    onClose();
  };

  const onFileSelected = (f) => {
    if (f.length > 0) {
      setImportFile(f[0]);
    }
  };

  const onImport = () => {
    if (importFile) {
      const formData = new FormData();
      formData.append('csv', importFile);
      if (accountMask) {
        formData.append('account_mask', accountMask);
      }
      setProcessingImport(true);

      fetch(
        '/c_card/transactions/import',
        'POST',
        formData,
        (response) => {
          const respData = response?.data || {};
          if (respData?.errors?.length > 0) {
            if (respData.generic_error) {
              toast.error(data.t.read('cc_transactions.import_failed') + ': ' + respData.errors);
            } else {
              setImportErrors(respData.errors);
              setImportFile('');
              if (importInputRef.current) importInputRef.current.value = '';
            }
            setProcessingImport(false);
            return;
          }
          toast.success(data.t.read('cc_transactions.import_successful'));
          refreshCcards();
          closeAndReset();
          setProcessingImport(false);
        },
        (error) => {
          console.log('Import error response:', error.response);
          if (error.response?.data?.errors?.length > 0) {
            if (error.response.data.generic_error) {
              toast.error(data.t.read('cc_transactions.import_failed') + ': ' + error.response.data.errors);
              return;
            }
            setImportErrors(error.response.data.errors);
            setImportFile('');
            if (importInputRef.current) importInputRef.current.value = '';
          } else {
            toast.error(data.t.read('cc_transactions.import_failed'));
            closeAndReset();
          }
          setProcessingImport(false);
        },
        true
      );
    }
  };

  return (
    <Modal
      width='50vw'
      title={data.t.read('importation')}
      cancelAction={closeAndReset}
      okAction={onImport}
      okText={data.t.read('import')}
      cancelText={data.t.read('cancel')}
      invalid={!importFile}
      noProcessingLoading={true}
    >
      <div>
        {data.t.read('supplier_table.csv_file_format')}
        <div className='card p-2'>
          {fileFormatExample}
          <br />
          {fileFormatExample}
          <br />
          {fileFormatExample}
          <br />
        </div>
        <div className='mt-2'>
          <input
            ref={importInputRef}
            className='form-control'
            style={{ height: 'fit-content' }}
            type='file'
            id='import-csv-file'
            onChange={(e) => onFileSelected(e.target.files)}
          />
        </div>
        {processingImport && (
          <div className='mt-3 ml-3'>
            <LoadingSpinner />
          </div>
        )}
        {importErrors.length > 0 && (
          <Accordion className='mt-3'>
            <AccordionSummary>
              <div className='text-danger d-flex align-items-center'>
                <FontAwesomeIcon icon={faChevronDown} style={{ marginRight: '8px' }} />
                {data.t.read('cc_transactions.import_failed')} ({importErrors.length})
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                {importErrors.map((err) => (
                  <div key={err.row_num} className='text-danger'>
                    {data.t.read('row')} {err.row_num} : {err.error}
                  </div>
                ))}
              </div>
            </AccordionDetails>
          </Accordion>
        )}
      </div>
    </Modal>
  );
};

export default ImportTransactionsModal;
